import React from "react";
import { HStack, Icon, Text } from "@chakra-ui/react";
import { MdInfoOutline } from "react-icons/md";

export const RemainingItemsBanner: React.FC = () => (
  <HStack
    mt={4}
    p={2}
    bg="orange.50"
    borderRadius="md"
    border="1px solid"
    borderColor="orange.200"
    spacing={2}
    align="center"
  >
    <Icon as={MdInfoOutline} color="orange.500" boxSize={3.5} />
    <Text
      fontSize="0.75rem"
      fontWeight="700"
      color="orange.700"
      fontFamily="'Nunito','Inter', sans-serif"
    >
      Delivery options are view-only as no supplier is available for these items.
    </Text>
  </HStack>
);
